if ( typeof ProductQuantity !== 'function' ) {

	class ProductQuantity extends HTMLElement {

		constructor(){

			super();

			const qty = this.querySelector('.qty-selector'),
						qtyMinus = this.querySelector('.qty-minus'),
						qtyPlus = this.querySelector('.qty-plus'),
						qtyMin = () => qty.getAttribute('min') ? parseInt(qty.getAttribute('min')) : 1,
						qtyMax = () => qty.getAttribute('max') ? parseInt(qty.getAttribute('max')) : 99999,
						qtyStep = () => qty.getAttribute('step') ? parseInt(qty.getAttribute('step')) : 1;

			/* PATCH – Theme-Bug 02 (Krown): min/max werden jetzt bei jedem Klick gelesen und
				 der disabled-Status beider Buttons an einer Stelle gesetzt. Vorher wurde die
				 disabled-Klasse nur im Plus-Handler entfernt, d.h. nachdem ein anderes Script
				 (Samita-Staffelzeile) qty.value programmatisch gesetzt hat, blieb Minus
				 dauerhaft deaktiviert und die Menge liess sich nur hochzaehlen.
				 Zusaetzlich wird jetzt "step" beruecksichtigt: die B2B-Staffelzeile setzt auf
				 dem Input ein step-Attribut (z.B. 12er-Kartons), das die +/- Buttons vorher
				 ignoriert und immer nur um 1 gerechnet haben. */
			const updateButtons = () => {
				const currentQty = parseInt(qty.value);
				qtyMinus.classList.toggle('disabled', isNaN(currentQty) || currentQty - qtyStep() < qtyMin());
				qtyPlus.classList.toggle('disabled', isNaN(currentQty) || currentQty + qtyStep() > qtyMax());
			};

			updateButtons();
			qty.addEventListener('input', updateButtons);

			qtyMinus.addEventListener('click', (e)=>{
				e.preventDefault();
				const currentQty = parseInt(qty.value),
							step = qtyStep();
				if ( currentQty - step >= qtyMin() ) {
					qty.value = currentQty - step;
				}
				updateButtons();
			});

			qtyPlus.addEventListener('click', (e)=>{
				e.preventDefault();
				const currentQty = parseInt(qty.value),
							step = qtyStep();
				if ( currentQty + step <= qtyMax() ) {
					qty.value = currentQty + step;
				}
				updateButtons();
			});

		}
		
	}


  if ( typeof customElements.get('product-quantity') == 'undefined' ) {
    customElements.define('product-quantity', ProductQuantity);
	}

}